import { createContext as e, useMemo as t, useState as S } from "react";
import { i as f } from "../../core-DVmjA3_O.js";
import "../../type-Dku6Xzl6.js";
function x(n) {
  if (!f(n))
    return n.direction === "asc" ? n.name : `-${n.name}`;
}
function C(n) {
  const [u, i] = S(n);
  return { sorting: u, setSorting: i };
}
const g = {
  sorting: void 0,
  setSorting: (n) => {
    console.warn("Trying to set to ", n);
  }
}, D = e(g);
function w(n, u, i) {
  const o = t(
    () => {
      const c = u.find((d) => d.id === (n == null ? void 0 : n.name));
      return c == null ? void 0 : c.valueComparator;
    },
    [u, n == null ? void 0 : n.name]
  );
  return t(
    () => f(i) || !o ? i : (n == null ? void 0 : n.direction) === "dsc" ? [...i].sort(o).reverse() : [...i].sort(o),
    [i, o, n == null ? void 0 : n.direction]
  );
}
export {
  D as SortContext,
  w as default,
  x as getOrdering,
  C as useSortState,
  w as useSorting
};
